// Libs
import { TFunction } from 'i18next';
import * as yup from 'yup';
// Others
import { EMPTY_STRING } from '~/utils/constants/common';
import { ICloneQuote } from '~/utils/interface/quotes';

export const schema = (t: TFunction): yup.ObjectSchema<ICloneQuote> => {
  return yup.object().shape({
    quoteId: yup.string().optional(),
    deliveryAddress: yup.object().optional(),
    startDate: yup.string().required(t('common_validate_field_required', { ns: 'common/base' })),
    startTime: yup.string().required(t('common_validate_field_required', { ns: 'common/base' })),
    endDate: yup.string().required(t('common_validate_field_required', { ns: 'common/base' })),
    endTime: yup.string().required(t('common_validate_field_required', { ns: 'common/base' })),
    isKeepPricing: yup.boolean().required(t('common_validate_field_required', { ns: 'common/base' })),
    isApplyPreviousCoupon: yup.boolean().required(t('common_validate_field_required', { ns: 'common/base' })),
    isKeepDiscountAmount: yup.boolean().required(t('common_validate_field_required', { ns: 'common/base' })),
    isKeepChargingDays: yup.boolean().required(t('common_validate_field_required', { ns: 'common/base' })),
    isCopyFiles: yup.boolean().required(t('common_validate_field_required', { ns: 'common/base' })),
    isCopyNotesAndComments: yup.boolean().required(t('common_validate_field_required', { ns: 'common/base' })),
  });
};

export const defaultValues: ICloneQuote = {
  quoteId: EMPTY_STRING,
  startDate: EMPTY_STRING,
  startTime: EMPTY_STRING,
  endDate: EMPTY_STRING,
  endTime: EMPTY_STRING,
  deliveryAddress: {},
  isKeepPricing: false,
  isApplyPreviousCoupon: false,
  isKeepDiscountAmount: false,
  isKeepChargingDays: false,
  isCopyFiles: false,
  isCopyNotesAndComments: false,
};
